import { Button } from 'antd';
import React from 'react';
const OldAppButton = () => (
  <>
    <Button type="primary" href="/OldAPP" style={{marginRight: "10px"}}>{Zgg.string("Old_APP")}</Button>
  </>
);
export default OldAppButton;